// extracted by css-extract-rspack-plugin
export default {"fieldWrapper":"MarkAsPaidModal_fieldWrapper__bsa46","currencyInputWrapper":"MarkAsPaidModal_currencyInputWrapper__Cq3M2","danger":"MarkAsPaidModal_danger__0vzaA"};